import {
  selectAll,
  event,
  addClass,
  removeClass,
  selectDoc,
} from "../utils/utils";

export class NavigationPage {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.navItem = selectDoc("[data-navigation-page-click]");
    this.body = document.body;
    this.navContainer = selectDoc(".navigation-page");
    this.headerContainer = selectDoc(".section-header");
  }

  render() {
    // this.reloadTop();
    this.setFixedMenu();

    const isIngredients =
      document.getElementsByClassName("page-ingredients").length > 0;
    const isScience =
      document.getElementsByClassName("page-science").length > 0;
    if (isIngredients) {
      this.progressMenu("column-text");
      this.progressMenu("topicals");
      this.progressMenu("supplements");
    }
    if (isScience) {
      this.progressMenu("science-approach", 80);
      this.progressMenu("science-nad");
      this.progressMenu("science-ingredients");
      this.progressMenu("grid-cards");
      this.progressMenu("science-blog");
    }
  }

  reloadTop = () => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  };

  progressMenu = (el, offset = 0) => {
    const headerContainer = this.headerContainer;
    const navContainer = this.navContainer;
    const section = el ? selectDoc(`.${el}`) : null;
    const itemMenu = el ? selectDoc(`.go-${el}`) : null;
    const isMobile = window.innerWidth < 768;
    const headerOffset = isMobile ? 107: 80;
    const menuOffset = isMobile ? 107: 80;
    const distanceFromTop = section
      ? (section.getBoundingClientRect().top - headerOffset * 2)
      : null;
    const heightSection = section.offsetHeight;
    event(document, "scroll", function () {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      const itemMenuLine = selectDoc(`.go-${el} span`);
 
      if (top > distanceFromTop) {
        const percent = (top - distanceFromTop) / 10;
        itemMenuLine.style.width = `${percent}%`;
      } else {
        itemMenuLine.style.width = `0px`;
      }
    });

    itemMenu.addEventListener("click", function (e) {
      e.preventDefault();
      const isNavSticky = navContainer.classList.contains("sticky");

      const navOffset = isNavSticky
        ? menuOffset
        : menuOffset + headerOffset - offset;

      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    });
  };

  setFixedMenu = () => {
    const navContainer = this.navContainer;
    const distanceFromTop = (navContainer.getBoundingClientRect().bottom) - 207;

    let oldValue = 0;
    let newValue = 0;
    window.addEventListener("scroll", () => {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      newValue = window.pageYOffset;
      if (oldValue < newValue) {
        if (top > distanceFromTop) {
          addClass(navContainer, "sticky");
        }
      } else if (oldValue > newValue) {
        if (top < distanceFromTop) {
          removeClass(navContainer, "sticky");
        }
      }
      oldValue = newValue;
    });
  };
}
